import type { WorkspaceInfo } from '../types/api'

/** Resolve Admin-local selection without mutating the main application
 * workspace. */
export function resolveAdminWorkspaceId(
  urlWorkspaceId: string | null,
  mainWorkspaceId: string | null,
  workspaces: WorkspaceInfo[],
): string {
  const ids = new Set(workspaces.map((workspace) => workspace.workspace_id))
  if (urlWorkspaceId && ids.has(urlWorkspaceId)) return urlWorkspaceId
  if (mainWorkspaceId && ids.has(mainWorkspaceId)) return mainWorkspaceId
  return workspaces[0]?.workspace_id ?? ''
}
